import { useAuthService } from './AuthService'
import { Capacitor } from '@capacitor/core'

const authService = useAuthService()
const authGuard = async (to, _from, next) => {
  if (await authService.isLoggedInAsync()) {
    next()
  } else if (Capacitor.isNativePlatform()) {
    await next({ name: 'login' })
  } else {
    await authService.loginAsync(window.location.origin + to.fullPath)
  }
}

export default authGuard
